// extracted by mini-css-extract-plugin
export var backgroundButton = "ARPromo-module--background-button---oWYz";
export var backgroundImage = "ARPromo-module--background-image--bEyGX";
export var desktopOnly = "ARPromo-module--desktop-only--yFv2m";
export var headerLogoImage = "ARPromo-module--header-logo-image--mCWmq";
export var inner = "ARPromo-module--inner--Gt0Rp";
export var innerText = "ARPromo-module--inner-text--CJUIx";
export var mobileOnly = "ARPromo-module--mobile-only--+dO18";
export var wrapper = "ARPromo-module--wrapper--708oT";